import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const CollapsibleSection = ({ 
  title, 
  emoji, 
  children, 
  language, 
  isInitiallyExpanded = false,
  disableExpand = false
}) => {
  const [isExpanded, setIsExpanded] = useState(isInitiallyExpanded);

  return (
    <div className="mt-6 bg-white dark:bg-gray-750 rounded-lg border border-love-100 dark:border-love-900 shadow-sm overflow-hidden">
      <motion.button
        className={`w-full flex items-center justify-between p-4 cursor-pointer group ${disableExpand ? 'cursor-default' : ''}`}
        onClick={() => !disableExpand && setIsExpanded(!isExpanded)}
        whileTap={disableExpand ? {} : { scale: 0.98 }}
      >
        <div className="flex items-center">
          <span className="emoji mr-2 text-lg">{emoji}</span>
          <h2 className="text-lg font-medium text-gray-800 dark:text-gray-200">
            {title}
          </h2>
        </div>
        {!disableExpand && (
          <motion.div
            animate={{ rotate: isExpanded ? 180 : 0 }}
            transition={{ duration: 0.3 }}
            className="text-gray-500 dark:text-gray-400 group-hover:text-love-500 dark:group-hover:text-love-400 transition-colors"
          >
            <SafeIcon icon={FiIcons.FiChevronDown} size={20} />
          </motion.div>
        )}
      </motion.button>
      
      <AnimatePresence initial={false}>
        {(isExpanded || disableExpand) && (
          <motion.div
            initial={disableExpand ? {} : { height: 0, opacity: 0 }}
            animate={disableExpand ? {} : { height: 'auto', opacity: 1 }}
            exit={disableExpand ? {} : { height: 0, opacity: 0 }}
            transition={{ duration: 0.3, ease: "easeInOut" }}
            className="overflow-hidden"
          >
            <div className="p-4 pt-0 border-t border-love-100 dark:border-love-900">
              {children}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default CollapsibleSection;